import React from 'react';

type LightboxDescriptionProps = {
  title?: string;
  description?: string;
};

const LightboxCaption: React.FC<LightboxDescriptionProps> = ({
  title,
  description,
}: LightboxDescriptionProps): React.ReactElement | null => {
  if (!title && !description) {
    return null;
  }

  return (
    <div>
      {title && <h3 className="lightbox-title">{title}</h3>}
      {description && <p className="lightbox-description">{description}</p>}
    </div>
  );
};

export default LightboxCaption;
